<template>
    <div :class="formClass" :style="formStyles">
        <div :class="portletClass">
            <div class="form-group m-form__group row" v-for="(info, key) in dataFields" :key="'data_'+key" v-if="renderRow(key, dataFields[key])">
                <div class="col-lg-6" v-if="dataFields[key] === 'string'">
                    <label class="">{{ inputLabel(key) | capitalize }}{{ isRequiredField(key) }} :</label>
                    <input type="text" class="form-control m-input" v-model="form[key]">
                </div>
                <div class="col-lg-10" v-else-if="dataFields[key] === 'longtext'">
                    <label class="">{{ inputLabel(key) | capitalize }}{{ isRequiredField(key) }} :</label>
                    <textarea rows="10" class="form-control m-input" v-model="form[key]"></textarea>
                </div>
                <template v-else-if="dataFields[key] === 'link'">
                    <div class="col-lg-6 input-group">
                        <input type="url" class="form-control m-input" :placeholder="inputLabel(key)" v-model="form[key]" @keyup="forceUpdate">
                        <div class="input-group-append">
                            <span class="input-group-text" :class="{'disabled': !form[key]}">
                                <a :href="form[key]" target="_blank"><i class="la la-globe"></i></a>
                            </span>
                        </div>
                    </div>
                    <div col="col-lg-1">{{ isRequiredField(key) }}</div>
                </template>
                <template v-else-if="(dataFields[key] !== 'string' && dataFields[key] !== 'longtext' && dataFields[key] !== 'link') && typeof dataFields[key] === 'string'">
                    <div class="col-lg-6" >
                        <label class="">{{ labels[key] | capitalize }}{{ isRequiredField(key) }} :</label>
                        <select :id="key" class="form-control m-choices" :class="'crud-choices-' + index" v-model="form[key]">
                            <option value="" disabled selected>{{ labels['type_to_search'] }}</option>
                            <option v-if="dataFields[key] === 'countries'" v-for="country in countries.fr" :value="country.alpha2.toUpperCase()" :selected="form[key] === country.alpha2.toUpperCase()">{{ country.name }}</option>
                        </select>
                    </div>
                    <extended-info
                            v-if="nestedForms[dataFields[key]] && item.field === key"
                            v-for="(item, index) in nestedForms[dataFields[key]]"
                            :key="dataFields[key] + 'NestedForm' + index"
                            index="new"
                            :param="dataFields[key]"
                            :itemIdName="getCRUDName(dataFields[key])"
                            :nestedForm="true"
                            :choices="item.choices"
                            :formKey="key"
                            :name="item.name"></extended-info>
                </template>

                <template v-if="Array.isArray(dataFields[key])">
                    <div class="col-lg-6" >
                        <label class="">{{ inputLabel(key)| capitalize  }}{{ isRequiredField(key) }} :</label>
                        <select :id="key" class="form-control m-choices" :class="'crud-choices-multi-' + index" v-model="form[key]" multiple>
                            <option value="" disabled selected>{{ labels['type_to_search'] }}</option>
                        </select>
                    </div>
                    <extended-info
                            v-if="nestedForms[dataFields[key][0]]"
                            v-for="(item, index) in nestedForms[dataFields[key][0]]"
                            :key="dataFields[key][0] + 'NestedForm' + index"
                            index="new"
                            :itemIdName="getCRUDName(dataFields[key][0])"
                            :param="dataFields[key][0]"
                            :nestedForm="true"
                            :choices="item.choices"
                            :formKey="key"
                            :name="item.name"></extended-info>
                </template>

            </div>
             <multi-upload-file :type="param" :object-id="data[itemIdName]" v-if="data && data[itemIdName]" />
            <show-files-link-to-object :type="param" :object-id="data[itemIdName]" labelTitle="list_uploaded_files" :withDelete="true" v-if="data && data[itemIdName]" />
        </div>
        <div class="m-form__actions m-form__actions" :class="{ 'nested-footer': nestedForm }" v-show="!hasNestedForm">
            <div class="row">
                <div :class="formType ? 'col-lg-2' : 'col-lg-1'">
                    <button type="button" data-dismiss="modal" class="btn btn-secondary" @click="closeAction(true)">{{ labels.cancel }}</button>
                </div>
                <div class="col-lg-2">
                    <button type="button" class="btn" :class="saveBtnClass" @click="saveForm" :disabled="inProgress">{{ formSaveLabel }}</button>
                </div>
                <div :class="formType ? 'col-lg-8' : 'col-lg-9'" style="text-align:right;">{{ labels.required_fields_info }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Choices from 'choices.js';
import * as algoliasearch from 'algoliasearch';
import { HTTP } from '../../assets/js/axiosConfig';
import { eventBus } from '../../main.js';

import Uuid from '../../assets/js/mixins';
import GetCRUDName from '../../assets/js/mixins';
import SweetAlert from '../../assets/js/mixins';
import SendPostRequest from '../../assets/js/mixins';
import UpdateFirestore from '../../assets/js/mixins';
import deleteProductAction from '../../assets/js/deleteProductMixin';
import MultiUploadFile from '../Upload/MultiUploadFile.vue';
import ShowFilesLinkToObject from '../Upload/ShowFilesLinkToObject.vue';

import ExtendedInfo from './ExtendedInfo';

import dataFields from '../../data/schemas/CRUD_data_structure.json';

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_KEY);
const productIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_products`);
const timer = 2000;

let storedProductLeaders = [];

export default {
  name: 'ExtendedInfo',
  props: ['param', 'itemIdName', 'data', 'index', 'name', 'nestedForm', 'choices', 'formKey', 'formType'],
  mixins: [Uuid, GetCRUDName, SweetAlert, SendPostRequest, UpdateFirestore, deleteProductAction],
  components: {
    ExtendedInfo,
    MultiUploadFile,
    ShowFilesLinkToObject,
  },
  data() {
    return {
      form: {},
      inProgress: false,
      nestedForms: {},
      hasNestedForm: false,
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      roles: (store) => store.roles,
      crudData: (store) => store.crudData.cruds,
      countries: (store) => store.countries,
      newCRUD: (store) => store.crudData.newCRUD,
    }),
    ...mapGetters([
      'getName',
    ]),
    dataFields() {
      return dataFields[this.param];
    },
    schema() {
      return dataFields;
    },
    portletClass() {
      return this.nestedForm ? '' : 'm-portlet__body';
    },
    formClass() {
      return this.nestedForm ? 'col-lg-12' : 'm-form__section m-form__section--third';
    },
    formStyles() {
      return this.nestedForm ? 'padding: 20px; margin: 5px; border: 1px solid #f0f0f0; border-radius: 5px;' : '';
    },
    formSaveLabel() {
      return this.nestedForm ? this.labels.save_to_continue : this.labels.save;
    },
    saveBtnClass() {
      return this.nestedForm ? 'btn-success' : 'btn-primary';
    },
  },
  methods: {
    ...mapActions([
      'toggleCRUDMode',
      'products/setFormModalData',
      'products/productSegmentAction',
      'products/updateSelectedSegments',
      'setNewCRUD',
      'setUserInfo',
    ]),
    forceUpdate() {
      this.$forceUpdate();
    },
    inputLabel(key) {
      if (this.dataFields.hasOwnProperty('custom_titles') && this.dataFields.custom_titles[key]) {
        return this.labels[this.dataFields.custom_titles[key]];
      }
      return this.labels[key];
    },
    renderRow(key, value) {
      return this.dataFields.columns.indexOf(key) !== -1;
    },
    isRequiredField(key) {
      const required = this.dataFields.required.filter((field) => field === key);
      return required.length ? '*' : null;
    },
    initChoices() {
      const my = this;
      $(`.crud-choices-${this.index}`).each(function () {
        const element = this;
        const elementId = $(this).attr('id');

        if (!$(element).hasClass('choices__input')) {
          const choicesSingle = new Choices(element, {
            searchChoices: true,
            shouldSort: false,
            removeItemButton: true,
            removeItems: true,
            callbackOnInit() {
              if (my.dataFields[elementId] === 'products') {
                if (my.form[elementId]) {
                  my.searchProducts(elementId, [`productId:${my.form[elementId]}`], this, false);
                }
                // We have to retrieve the products list from Algolia
                // We set a search listener in order to populate the choices that match the search
                $('.choices__input').on('keydown', function (event) {
                  // 1) Find resource by search text
                  // 2) If id does not exist make a request to create new resource entry
                  // 3) Update the choice list with new resource
                  const parent = $(this).parents()[1];
                  const sameFamily = $(parent).find(`#${elementId}`).length;
                  if (sameFamily) {
                    my.searchProducts(elementId, event.currentTarget.value, choicesSingle, false);
                  }
                });
              } else if (my.dataFields[elementId] !== 'countries') {
                my.getChoices(elementId, my.dataFields[elementId], this, [], false);
              }
            },
          });

          $('.choices__input').on('keydown', function (event) {
            // 1) Find resource by search text
            // 2) If id does not exist make a request to create new resource entry
            // 3) Update the choice list with new resource
            const parent = $(this).parents()[1];
            const sameFamily = $(parent).find(`#${elementId}`).length;
            if (event.keyCode === 13 && sameFamily && elementId.indexOf('segmentation') === -1 && my.dataFields[elementId] !== 'countries') {
              event.preventDefault();
              event.stopPropagation();
              const { value } = event.currentTarget;
              my.findResourceByName(my.dataFields[elementId], value, choicesSingle, elementId);
            }
          });
        }
      });

      $(`.crud-choices-multi-${this.index}`).each(function () {
        const element = this;
        const elementId = $(this).attr('id');
        if (!$(element).hasClass('choices__input')) {
          const choicesMulti = new Choices(element, {
            searchChoices: true,
            shouldSort: false,
            removeItems: true,
            removeItemButton: true,
            callbackOnInit() {
              if (my.dataFields[elementId][0] !== 'products') {
                my.getChoices(elementId, my.dataFields[elementId][0], this, [], true);
              } else {
                if (my.form[elementId] && my.form[elementId].length) {
                  const facetFilters = [];
                  my.form[elementId].map((value) => facetFilters.push(`productId:${value}`));
                  my.searchProducts(elementId, facetFilters, this, true);
                }
                // We have to retrieve the products list from Algolia
                // We set a search listener in order to populate the choices that match the search
                $('.choices__input').on('keydown', function (event) {
                  const parent = $(this).parents()[1];
                  const sameFamily = $(parent).find(`#${elementId}`).length;
                  if (sameFamily) {
                    my.searchProducts(elementId, event.currentTarget.value, choicesMulti, true);
                  }
                });
              }
            },
          });

          $('.choices__input').on('keydown', function (event) {
            const parent = $(this).parents()[1];
            const sameFamily = $(parent).find(`#${elementId}`).length;
            if (event.keyCode === 13 && sameFamily && elementId.indexOf('segmentation') === -1) {
              event.preventDefault();
              event.stopPropagation();
              const { value } = event.currentTarget;
              my.findResourceByName(my.dataFields[elementId][0], value, choicesMulti);
            }
          });
        }
      });
    },
    findResourceByName(resource, search, choices, field) {
      const results = this.crudData[resource].filter((data) => {
        const dataName = data.name.toLowerCase();
        const searchText = search.toLowerCase();
        if (dataName.indexOf(searchText) !== -1) {
          return data;
        }
      });
      if (!results.length) {
        this.createNewEntry(resource, search, choices, field);
      }
    },
    createNewEntry(resource, name, choices, field) {
      // Create new resource object
      const item = {
        name,
        choices,
        field,
      };
      this.nestedForms[resource] = [];
      this.nestedForms[resource].push(item);
      this.hasNestedForm = true;
      this.$forceUpdate();
      this.$nextTick(function () {
        this.initChoices();
      });
    },
    resetChoices(thisChoice, resourceId, element, entryId) {
      const choices = [];
      this.crudData[element].map((resource) => {
        const choice = {
          value: resource[resourceId],
          label: resource.name,
          selected: this.isSelected(resource[resourceId], entryId),
        };
        choices.push(choice);
      });
      thisChoice.setChoices(choices, 'value', 'label', true);
    },
    getChoices(formKey, element, choiceObj, results, isMultiChoice) {
      // First find crud name
      const choices = [];
      const idName = this.getCRUDName(element);
      if (element === 'segmentations') {
        this.crudData[element].map((item) => {
          const data = {
            value: item[idName],
            label: `${this.getName(item.theme_id, 'theme_id', 'themes')} - ${item.name}`,
            selected: this.isSelected(item[idName], this.form[formKey], isMultiChoice, idName),
          };
          choices.push(data);
        });
      } else if (element !== 'products') {
        this.crudData[element].map((item) => {
          const data = {
            value: item[idName],
            label: item.name,
            selected: this.isSelected(item[idName], this.form[formKey], isMultiChoice, idName),
          };
          choices.push(data);
        });
      } else {
        choices.push({ value: '', label: 'None', selected: false });
        results.map((item) => {
          let checkedItems = [];
          if (choiceObj && choiceObj._currentState && choiceObj._currentState.items.length) {
            checkedItems = choiceObj._currentState.items.filter((currentItem) => currentItem.value === item.productId);
          }
          if (!checkedItems.length) {
            const data = {
              value: item.productId,
              label: `${item.brandName || ''}, ${item.collectionName || ''}, ${item.name || ''}`,
              selected: this.isSelected(item.productId, this.form[formKey], isMultiChoice),
            };
            choices.push(data);
          }
        });
      }

      choiceObj.setChoices(choices, 'value', 'label', true);
    },
    isSelected(itemId, value, isMultiChoice, idName) {
      if (isMultiChoice) {
        // Check if choice is already selected
        return value.indexOf(itemId) !== -1 || value.filter((val) => val[idName] === itemId).length;
      }
      return itemId === value;
    },
    searchProducts(formKey, filter, choiceObj, isMultiChoice) {
      const my = this;
      productIndex.search({
        distinct: true,
        query: !Array.isArray(filter) ? filter : '',
        page: 0,
        facetFilters: Array.isArray(filter) ? [filter] : '',
        hitsPerPage: 1000,
        attributesToRetrieve: [
          'brandName',
          'productId',
          'collectionName',
          'name',
        ],
      },
      (err, content) => {
        if (err) throw err;
        my.getChoices(formKey, 'products', choiceObj, content.hits, isMultiChoice);
      });
    },
    saveForm() {
      this.inProgress = true;
      if (!this.data || this.index === 'new') {
        // Send POST request
        this.param === 'themes' ? this.saveThemeForm() : this.sendPostRequest(this.param, this.form, this.closeAction, this.itemIdName);
      } else {
        this.updateItem();
      }
    },
    saveThemeForm() {
      const themeForm = {
        theme_id: this.form.theme_id,
        name: this.form.name,
      };
      this.sendPostRequest(this.param, themeForm, this.updateProductLeadersFirestore);
    },
    updateProductLeadersFirestore() {
      if (this.form.product_leaders.length) {
        this.form.product_leaders.forEach((prodLeader) => {
          this.updateProductLeaders(prodLeader, this.form.theme_id);
        });
      }
      // Delete Firestore reference of product leader when removed from theme
      if (storedProductLeaders.length) {
        storedProductLeaders.forEach((leader) => {
          if (this.form.product_leaders.indexOf(leader) === -1) {
            this.deleteProductLeaderFirestore(leader);
          }
        });
      }
      this.closeAction(null, this.itemIdName);
    },
    updateItem() {
      // Check if item has been edited before sending request
      HTTP.put(`api/${this.param}/${this.form[this.itemIdName]}`, this.form)
        .then((response) => {
          // 1. Reset create view
          this.toggleCRUDMode(null);
          this.sweetAlert('success', this.labels.saved, timer);
          this.inProgress = false;
          this.updateFirestore(this.param);
          this.param === 'themes' ? this.updateProductLeadersFirestore() : null;
        })
        .catch((err) => {
          console.log(err);
          const title = `${this.labels.error_updating} ${this.param} : ${this.form.name}`;
          this.sweetAlert('error', title, timer);
          this.inProgress = false;
        });
    },
    closeAction(close, id) {
      if (!this.nestedForm) {
        this.toggleCRUDMode(null);
        this['products/setFormModalData'](null);
        this['products/productSegmentAction']({ index: null });
        this['products/updateSelectedSegments']({ action: 'add', value: id });
        $('#formModalClose').trigger('click');
        !close ? this.sweetAlert('success', this.labels.saved, timer) : null;
      } else {
        eventBus.$emit('closeAction', this.choices, this.itemIdName, this.param, this.form[this.itemIdName], this.formKey);
      }
    },
    buildDataFields() {
      this.form = {};
      for (const key in this.dataFields) {
        if (key === this.itemIdName) {
          this.form[key] = this.uuid();
        } else if (this.dataFields.columns.indexOf(key) !== -1) {
          Array.isArray(this.dataFields[key]) ? this.form[key] = [] : this.form[key] = '';
        }
      }
    },
  },
  mounted() {
    this.initChoices();
    storedProductLeaders = [];

    if (this.data && this.data.hasOwnProperty('product_leaders') && this.param === 'themes') {
      this.data.product_leaders.forEach((prodLeader) => {
        storedProductLeaders.push(prodLeader);
      });
    }
  },
  created() {
    this.buildDataFields();

    // Sync with existing data values
    if (this.data) {
      for (const key in this.data) {
        this.form[key] = this.data[key];
      }
    }
    // If there is a name value we pre-fill the name field with this value
    this.name ? this.form.name = this.name : null;

    eventBus.$on('closeAction', (choices, resourceId, element, entryId, formKey) => {
      this.nestedForms[element] = [];
      this.form[formKey] = entryId;
      this.hasNestedForm = false;
      this.$forceUpdate();
      this.$nextTick(function () {
        this.resetChoices(choices, resourceId, element, entryId);
      });
    });
  },
};
</script>

<style>
    .disabled {
        pointer-events: none;
    }
    .disabled a {
        color: #9a9caf;
    }
</style>



// WEBPACK FOOTER //
// src/components/CRUDs/ExtendedInfo.vue